<template>
  <div class="generated-summary-main-container grid-container margin-top-s medium-margin-top-m margin-bottom-m padding-z">
    <div v-if="generatedSummary" class="generated-summary-wrapper generated-summary-wrapper--expanded">
      <h5 class="margin-bottom-xxs">Here's what customers think</h5>
      <ul v-if="isBulletSummary" class="body-regular margin-left-xs">
        <li v-for="bulletSummary in generatedSummary.summary" :key="bulletSummary">
          {{ bulletSummary }}
        </li>
      </ul>
      <div v-else class="body-regular">"{{ generatedSummary.summary }}"</div>
      <div class="margin-top-xxs body-small">AI-generated summary from {{ totalResultsFormatted }} customers reviews.</div>
    </div>
    <hr class="custom-gray-divider margin-top-s large-margin-top-m margin-bottom-z" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useReviews from '~/modules/reviews/composables/useReviews';
import useReviewsSummary from '~/modules/reviews/stores/useReviewsSummaryStore';
import { thousandsSeparator } from '~/utils/thousandsSeparator';

const { totalResults } = useReviews();
const { generatedSummary, isBulletSummary } = useReviewsSummary();
const totalResultsFormatted = computed(() => thousandsSeparator(generatedSummary?.totalReviewsAtSummary ?? (totalResults.value || 0)));
</script>

<style lang="scss" scoped>
@import '@core/csg/src/scss/typography/typography-mixins.scss';

.generated-summary-wrapper--expanded {
  max-width: rem-calc(951);
}

.body-regular {
  @include body(regular);
}

.body-small {
  @include body(small);
}
</style>
